import { render, staticRenderFns } from "./RecommonCards.vue?vue&type=template&id=6c3b3f54&scoped=true&"
import script from "./RecommonCards.vue?vue&type=script&lang=js&"
export * from "./RecommonCards.vue?vue&type=script&lang=js&"
import style0 from "./RecommonCards.vue?vue&type=style&index=0&id=6c3b3f54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b3f54",
  null
  
)

export default component.exports